









import {Component, Prop} from 'vue-property-decorator'
import Vue from 'vue'
import { AppModule} from '@/store/modules/app'
import { RailwayApi } from '@/rest/apis'
import { RailwayModule } from '@/store/modules/railway'
import { Configuration } from '@/rest';
import ShoppingCartButton from '@/components/common/ShoppingCartButton.vue'

@Component({
    name: "cart-button"
})
export default class CartButton extends ShoppingCartButton {
    @Prop({}) private isMobile: boolean | undefined
    private isLoading: boolean = false
    
    addToShoppingCart(): void { 
        this.isLoading = true;
        
        let railwayApi = new RailwayApi(
            new Configuration({ basePath: '/rest'})
        )
        railwayApi.addRailway(RailwayModule.railwayTransfer).then((value: any) => {AppModule.SetIsClean(true);Vue.nextTick(function() {window.location.href = value})}, 
            (reason: any) => {window.console.log(reason); this.isLoading = false;})        
    }

    get allStepsCompleted(): boolean {
        return AppModule.allStepsCompleted
    }

    get productType(): string | undefined {
        return AppModule.session.productType
    }
}
